// @router
import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/components/base/routerParrent.vue");
const personPage = () => import("../views/person/personPage.vue");
const editPerson = () => import("../views/person/editPerson.vue");
const editUser = () => import("../views/user/editUser.vue");
const changePassword = () => import("../views/user/changePass.vue");
const editCompany = () => import("../views/company/editCompany.vue");
const AddUser = () => import("../views/user/addUser.vue");
const AddCompany = () => import("../views/company/addCompany.vue");
const AddPerson = () => import("../views/person/addPersonNew.vue");
const roleTree = () => import("../views/role/roleTree.vue");
const AddRole = () => import("../views/role/addRole.vue");
const EditRole = () => import("../views/role/editRole.vue");
const searchPerson = () => import("../views/person/searchPerson.vue");
const searchCompany = () => import("../views/company/searchCompany.vue");
const searchUser = () => import("../views/user/searchUser.vue");
const searchParvandehArchive = () =>
  import("../views/parvandeh/searchParvandehArchive.vue");
// const searchParvandeh = () => import("../views/parvandeh/searchParvandeh.vue");
const parvandehCancel = () =>
  import("../views/parvandeh/cancelParvandeh/index.vue");
const AssignRolePermissions = () =>
  import("../views/role/assignRolePermissions.vue");
const accessForAllRoles = () => import("../views/role/accessForAllRoles.vue");
const SearchEnum = () => import("../views/enum/searchEnum.vue");
const AddEnum = () => import("../views/enum/addEnum.vue");
const EditEnum = () => import("../views/enum/editEnum.vue");
const DesignPdfPage = () => import("../views/pdfpage/DesignPdfPage.vue");
import newRegister from "../views/register/newRegister.vue";
import searchTerm from "../views/term/searchTerm.vue";
import addTerm from "../views/term/addTerm.vue";
// import editTerm from "../views/term/editTerm.vue";
import editTermState from "../views/term/editTermState.vue";
import registerCodeManager from "../views/term/registerCodeManager.vue";
import changeMobile from "../views/user/changeMobile.vue";
// import searchHozehGhazayi from "../views/hozehGhazayi/searchHozehGhazayi.vue";
// import selectHozehGazayiProvince from "../views/hozehGhazayi/selectHozehGazayiProvince.vue";
// import transferHozehGazayiProvince from "../views/hozehGhazayi/transferHozehGazayiProvince.vue";
// import selectHozehGazayiDetail from "../views/hozehGhazayi/selectHozehGazayiDetail.vue";
// import transferHozehGazayiDetail from "../views/hozehGhazayi/transferHozehGazayiDetail.vue";
import searchPersonIdentity from "../views/personIdentity/searchPersonIdentity.vue";
const searchReportAccess = () =>
  import("../views/reportAccess/searchReportAccess.vue");
const audio = () =>
  import("../../../components/re-design/audio-recorder/AudioRecorderNew.vue");

const searchParvandeh = () =>
  import("../views/parvandeh/re-design/searchParvandeh.vue");
const addParvandeh = () =>
  import("../views/parvandeh/re-design/addParvandeh.vue");
const editParvandeh = () =>
  import("../views/parvandeh/re-design/editParvandeh.vue");
const changeUserInformation = () =>
  import("../views/change-user-information/changeUserInformation.vue");
const whatsNewList = () => import("../views/whats-new/whats-new-list.vue");
const termsList = () => import("../views/term/re-design/termsList.vue");
const editTerm = () => import("../views/term/re-design/editTerm.vue");

export const profileRoutes: RouteConfig[] = [
  {
    path: "/profile",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      {
        path: "company",
        name: "company",
        meta: {
          label: "شرکت",
          requiresAuth: true,
        },
        component: routerParent,
        redirect: "/profile/company/list",
        children: [
          {
            path: "list",
            name: "company-list",
            component: searchCompany,
            meta: {
              label: "لیست شرکت ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "self",
        name: "profile-page",
        component: routerParent,
        meta: {
          label: "نمایه من",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: ":code?/edit",
            name: "profile",
            meta: {
              label: "ویرایش نمایه من",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/identity",
            name: "profile-identity",
            meta: {
              label: "مشخصات اصلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/information",
            name: "profile-information",
            meta: {
              label: "ویرایش اطلاعات تکمیلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/contact",
            name: "profile-contact",
            meta: {
              label: "ویرایش اطلاعات تماس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/address",
            name: "profile-address",
            meta: {
              label: "ویرایش اطلاعات آدرس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/work-experience",
            name: "profile-work-experience",
            meta: {
              label: "ویرایش سوابق شغلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/education",
            name: "profile-education",
            meta: {
              label: "ویرایش سوابق تحصیلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/socail",
            name: "profile-social",
            meta: {
              label: "ویرایش سوابق فرهنگی اجتماعی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/quote",
            name: "profile-quote",
            meta: {
              label: "ویرایش سهمیه ایثارگری",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/license",
            name: "profile-license",
            meta: {
              label: "ویرایش مجوز ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/course",
            name: "profile-course",
            meta: {
              label: "ویرایش دوره ها و همایش ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/article",
            name: "profile-article",
            meta: {
              label: "ویرایش مقاله ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/wife-info",
            name: "profile-wife-info",
            meta: {
              label: "ویرایش مشخصات همسر",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/family-relation",
            name: "profile-family-relation",
            meta: {
              label: "ویرایش اعضا خانواده",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/financial-information",
            name: "profile-financial-information",
            meta: {
              label: "ویرایش اطلاعات مالی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/year-of-service",
            name: "profile-year-of-service",
            meta: {
              label: "ویرایش سوابق خدمت",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/teaching-experience",
            name: "profile-teaching-experience",
            meta: {
              label: "ویرایش سوابق تدریس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/representative",
            name: "profile-representative",
            meta: {
              label: "ویرایش معرف",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/relation/:id?/:relation_with",
            name: "profile-relation",
            meta: {
              label: "ویرایش افراد مرتبط",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/skills",
            name: "profile-skills",
            meta: {
              label: "ویرایش مهارت ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code?/attachments",
            name: "profile-attachments",
            meta: {
              label: "پیوست ها",
              requiresAuth: true,
              deprecated: true,
            },
          },

          {
            path: ":code/azmoon",
            name: "profile-azmoon",
            meta: {
              label: "آزمون های مرتبط",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "other",
        name: "person-page",
        component: routerParent,
        meta: {
          label: "نمایه فردی",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: ":code/parvandeh/:parvandehCode/edit",
            name: "editPerson", // this route for old usage this route in pages
            meta: {
              label: "ویرایش نمایه فردی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/edit",
            name: "person",
            meta: {
              label: "ویرایش نمایه فردی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/identity",
            name: "person-identity",
            meta: {
              label: "مشخصات اصلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/contact",
            name: "person-contact",
            meta: {
              label: "ویرایش اطلاعات تماس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/information",
            name: "person-information",
            meta: {
              label: "ویرایش اطلاعات تکمیلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/address",
            name: "person-address",
            meta: {
              label: "ویرایش اطلاعات آدرس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/work-experience",
            name: "person-work-experience",
            meta: {
              label: "ویرایش سوابق شغلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/education",
            name: "person-education",
            meta: {
              label: "ویرایش سوابق تحصیلی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/socail",
            name: "person-social",
            meta: {
              label: "ویرایش سوابق فرهنگی اجتماعی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/quote",
            name: "person-quote",
            meta: {
              label: "ویرایش سهمیه ایثارگری",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/license",
            name: "person-license",
            meta: {
              label: "ویرایش مجوز ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/course",
            name: "person-course",
            meta: {
              label: "ویرایش دوره ها و همایش ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/article",
            name: "person-article",
            meta: {
              label: "ویرایش مقاله ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/wife-info",
            name: "person-wife-info",
            meta: {
              label: "ویرایش مشخصات همسر",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/family-relation",
            name: "person-family-relation",
            meta: {
              label: "ویرایش اعضا خانواده",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/financial-information",
            name: "person-financial-information",
            meta: {
              label: "ویرایش اطلاعات مالی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/inquiry",
            name: "person-inquiry",
            meta: {
              label: "ویرایش استعلامات",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/year-of-service",
            name: "person-year-of-service",
            meta: {
              label: "ویرایش سوابق خدمت",
              requiresAuth: true,
              deprecated: true,
            },
          },

          {
            path: ":code/parvandeh/:parvandehCode/teaching-experience",
            name: "person-teaching-experience",
            meta: {
              label: "ویرایش سوابق تدریس",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/representative",
            name: "person-representative",
            meta: {
              label: "ویرایش معرف",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/relation/:id?/:relation_with",
            name: "person-relation",
            meta: {
              label: "ویرایش افراد مرتبط",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/skills",
            name: "person-skills",
            meta: {
              label: "ویرایش مهارت ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/special-attachments",
            name: "person-special-attachments",
            meta: {
              label: "پیوست های ویژه",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/parvandeh/:parvandehCode/attachments",
            name: "person-attachments",
            meta: {
              label: "پیوست ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/azmoon",
            name: "person-azmoon",
            meta: {
              label: "آزمون های مرتبط",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "parvandeh",
        name: "parvandeh",
        component: routerParent,
        redirect: "/profile/parvandeh/list",
        meta: {
          label: "پرونده‌",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "parvandeh",
            component: searchParvandeh,
            meta: {
              label: "پرونده‌های افراد",
              requiresAuth: true,
              redesigned: true,
              deprecated: true,
            },
          },
          {
            path: "search-archive",
            name: "parvandeh_archive",
            component: searchParvandehArchive,
            meta: {
              label: "پرونده‌های مختومه",
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "add-parvandeh",
            component: addParvandeh,
            meta: {
              label: "ایجاد پرونده جدید",
              requiresAuth: true,
              redesigned: true,
              deprecated: true,
            },
          },
          {
            path: "edit/:code",
            name: "edit-parvandeh",
            component: editParvandeh,
            meta: {
              label: "گزینه های بیشتر",
              requiresAuth: true,
              redesigned: true,
              deprecated: true,
            },
          },
          {
            path: "search/:parvandeh_number?",
            name: "parvandeh_by_number",
            component: searchParvandeh,
            meta: {
              label: "پرونده‌های افراد",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "cancel",
            name: "parvandeh_cancel",
            component: parvandehCancel,
            meta: {
              label: "درخواست انصراف از پرونده",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "report-access",
        name: "report_access",
        component: routerParent,
        redirect: "/profile/report-access/search",
        meta: {
          label: "دسترسی به گزارش های بارگذاری شده",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "report_access",
            component: searchReportAccess,
            meta: {
              label: "لیست دسترسی به گزارش های بارگذاری شده",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "term",
        name: "term",
        component: routerParent,
        redirect: "/profile/term/list",
        meta: {
          label: "دوره‌ها",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "term",
            component: termsList,
            meta: {
              label: "لیست دوره‌ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "add_term",
            component: addTerm,
            meta: {
              label: "افزودن دوره",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "edit/:code",
            name: "edit-term",
            component: editTerm,
            meta: {
              label: "ویرایش دوره",
              requiresAuth: true,
              deprecated: true,
              hasBottomNavigation: false,
            },
          },
          {
            path: ":term_code/term_state/:term_state_code",
            name: "edit_term_state",
            component: editTermState,
            meta: {
              label: "ویرایش مراحل دوره",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "register-code-manager/:code",
            name: "term_register_code_manager",
            component: registerCodeManager,
            meta: {
              label: "مدیریت کدهای ثبت نام",
              requiresAuth: true,
            },
          },
        ],
      },
      // {
      //   path: "person",
      //   name: "person",
      //   component: routerParent,
      //   redirect: "/profile/person/search",
      //   meta: {
      //     label: "فرد",
      //     requiresAuth: true,
      //   },
      //   children: [
      //     {
      //       path: "search",
      //       name: "searchPerson",
      //       component: searchPerson,
      //       meta: {
      //         label: "جستجوی فرد",
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: "add",
      //       name: "addPerson",
      //       component: AddPerson,
      //       meta: {
      //         label: "ثبت فرد",
      //         requiresAuth: true,
      //       },
      //     },
      //     {
      //       path: "edit/:code/:target?",
      //       name: "editPerson",
      //       component: personPage,
      //       meta: {
      //         label: "ویرایش نمایه فردی",
      //         requiresAuth: true
      //       }
      //     },

      //     {
      //       path: ":code/DesignPdfPage",
      //       name: "DesignPdfPage",
      //       component: DesignPdfPage,
      //       meta: {
      //         label: "اطلاعات فردی",
      //         requiresAuth: true,
      //       },
      //     },
      //   ],
      // },
      {
        path: "my/edit/:code?/:target?",
        name: "profile",
        component: personPage,
        meta: {
          label: "ویرایش نمایه من",
          requiresAuth: true,
        },
      },
      {
        path: "roles",
        name: "role",
        redirect: "/profile/roles/list",
        component: routerParent,
        meta: {
          label: "نقش",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "searchRole",
            component: roleTree,
            meta: {
              label: "جستجوی نقش",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "addRole",
            component: AddRole,
            meta: {
              label: "درج نقش",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "edit/:id",
            name: "editRole",
            component: EditRole,
            meta: {
              label: "ویرایش نقش",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":id/permissions",
            name: "assignRolePermissions",
            component: AssignRolePermissions,
            meta: {
              label: "دسترسی‌های نقش",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "access",
            name: "accessForAllRoles",
            component: accessForAllRoles,
            meta: {
              label: "دسترسی‌های یک منبع برای تمام نقش‌ها",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "applyLicense",
        name: "apply_license",
        redirect: "/profile/applyLicense/search",
        component: routerParent,
        meta: {
          label: "کاربری",
          requiresAuth: true,
        },
      },
      {
        path: "register",
        name: "register",
        redirect: "/profile/register",
        component: routerParent,
        meta: {
          label: "اطلاعات کاربری",
          requiresAuth: true,
        },
        children: [
          {
            path: "/",
            name: "register",
            component: newRegister,
            meta: {
              label: "ثبت‌نام",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "enumeration",
        name: "enumeration",
        redirect: "/profile/enumeration/list",
        // component: routerParent,
        meta: {
          label: "مقادیر پایه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "enumeration",
            // component: EditableEnum,
            meta: {
              label: "عنوان دسته بندی",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":category/search",
            name: "searchEnumeration",
            component: SearchEnum,
            meta: {
              label: "جستجوی مقادیر پایه",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "add",
            name: "addEnum",
            // component: AddEnum,
            meta: {
              label: "درج مقادیر پایه",
              deprecated: true,
            },
          },
          {
            path: "edit/:id",
            name: "editEnum",
            // component: EditEnum,
            meta: {
              label: "ویرایش مقادیر پایه",
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "hozeh-ghazayi",
        name: "hozeh_ghazayi",
        // component: routerParent,
        redirect: "/profile/hozeh-ghazayi/list",
        meta: {
          label: "حوزه قضایی",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "all_hozeh_ghazayi",
            meta: {
              label: "لیست حوزه ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "select-province",
            name: "person_hozeh_ghazayi",
            meta: {
              label: "انتخاب حوزه استانی",
              requiresAuth: true,
              deprecated: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
            },
          },
          {
            path: "select-detail",
            name: "select_hozeh_ghazayi_detail",
            meta: {
              label: "انتخاب حوزه نهایی",
              requiresAuth: true,
              deprecated: true,
              hasMaxWidth: false,
              hasBottomNavigation: false,
            },
          },
        ],
      },
      {
        path: "person-identity",
        name: "person_identity",
        // component: routerParent,
        redirect: "/profile/person-identity/list",
        meta: {
          label: "تغییر اطلاعات هویتی",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "person_identity_change",
            // component: searchPersonIdentity,
            meta: {
              label: "درخواست‌های تغییر اطلاعات هویتی",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "whats-new",
        name: "whats_new",
        component: routerParent,
        redirect: "/profile/whats-new/list",
        meta: {
          label: "تاریخچه تغییرات",
          requiresAuth: true,

          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "whats-new-list",
            component: whatsNewList,
            meta: {
              label: "تاریخچه تغییرات",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "folder",
        name: "folder",
        // component: routerParent,
        redirect: "/profile/folder/list",
        meta: {
          label: "دسته بندی",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "folder",
            // component: folderList,
            meta: {
              label: "دسته بندی",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "active-users",
        name: "active-users",
        component: routerParent,
        redirect: "/profile/active-users/list",
        meta: {
          label: "کاربران فعال در سامانه",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "active_user_history",
            meta: {
              label: "کاربران فعال در سامانه",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
      {
        path: "change-information",
        name: "change-user-information",
        component: changeUserInformation,
        meta: {
          label: "تغییر مشخصات کاربری",
          requiresAuth: true,
          redesigned: true,
          deprecated: true,
        },
      },
    ],
  },
  {
    path: "/user",
    name: "dynamic_home",
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    component: newContainer,
    children: [
      /* {
        path: "users",
        name: "users",
        component: routerParent,
        redirect: "/users/search",
        meta: {
          label: "کاربر",
          requiresAuth: true,
        },
        children: [
          {
            path: "search",
            name: "searchUser",
            component: searchUser,
            meta: {
              label: "جستجوی کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "add",
            name: "AddUser",
            component: AddUser,
            meta: {
              label: "درج کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code",
            name: "editUser",
            component: editUser,
            meta: {
              label: "ویرایش کاربر",
              requiresAuth: true,
            },
          },
          {
            path: "change_pass",
            name: "changePassword",
            component: changePassword,
            meta: {
              label: "تغییر گذرواژه",
              requiresAuth: true,
            },
          },
          {
            path: "change-mobile",
            name: "change_mobile",
            component: changeMobile,
            meta: {
              label: "تغییر شماره همراه",
              requiresAuth: true,
            },
          },
          
        ],
      }, */
    ],
  },
  {
    path: "/center-des-avocats",
    name: "centerDesAvocats",
    meta: {
      label: "مزکز وکلا",
      requiresAuth: true,
      deprecated: true,
    },
    // component: newContainer,
    children: [
      {
        path: "inquiry",
        name: "inquiry",
        // component: routerParent,
        redirect: "/center-des-avocats/inquiry/search",
        meta: {
          label: "استعلام",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "search",
            name: "search_inquiry",
            // component: searchInquiry,
            meta: {
              label: "استعلامات",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: "person/:code/edit/:id",
            name: "editInquiry",
            // component: editInquiry,
            meta: {
              label: "ویرایش...",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/national-license",
    name: "national-license",
    meta: {
      label: "مرکز ملی مجوز ها",
      requiresAuth: true,
      deprecated: true,
    },
    component: newContainer,
    children: [
      {
        path: "national-license-center",
        name: "national_licensing_center",
        component: routerParent,
        redirect: "/national-license/national-license-center/list",
        meta: {
          label: "درخواست ها",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "national-licensing-center-list",
            meta: {
              label: "درخواست ها",
              requiresAuth: true,
              deprecated: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: "/extra-profile",
    name: "extra-profile",
    meta: {
      label: "خانه",
      moduleName: "extraProfile",
      deprecated: true,
    },
    component: newContainer,
    children: [
      {
        path: "my-register-person",
        name: "my_register_person",
        component: routerParent,
        redirect: "/extra-profile/my-register-person/list",
        meta: {
          label: "معرفی دولتمردان",
          requiresAuth: true,
          deprecated: true,
        },
        children: [
          {
            path: "list",
            name: "my-register-person-list",
            // component: myRegisterPersonList,
            meta: {
              label: "معرفی دولتمردان",
              requiresAuth: true,
              deprecated: true,
            },
          },
          {
            path: ":code/tags",
            name: "my-register-person-tags",
            // component: myRegisterPersonTagsLevel,
            meta: {
              label: "ویرایش معرفی دولتمردان",
              requiresAuth: true,
              deprecated: true,
              hasBottomNavigation: false,
            },
          },
          {
            path: ":code/exam-packs",
            name: "my-register-person-exam-packs",
            // component: myRegisterPersonExamPacksLevel,
            meta: {
              label: "ویرایش معرفی دولتمردان",
              requiresAuth: true,
              deprecated: true,
              hasBottomNavigation: false,
            },
          },
        ],
      },
    ],
  },
];
